import { render, staticRenderFns } from "./CustomerBalance.vue?vue&type=template&id=d8fce2a0&scoped=true&"
import script from "./CustomerBalance.vue?vue&type=script&lang=js&"
export * from "./CustomerBalance.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBalance.vue?vue&type=style&index=0&id=d8fce2a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fce2a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
